var t={textWeight:"Strong"};export{t as default};
